import { render, staticRenderFns } from "./statewide-make.vue?vue&type=template&id=01de52fc&scoped=true"
import script from "./statewide-make.vue?vue&type=script&lang=js"
export * from "./statewide-make.vue?vue&type=script&lang=js"
import style0 from "./statewide-make.vue?vue&type=style&index=0&id=01de52fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de52fc",
  null
  
)

export default component.exports